"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Profile = function () {
    return (React.createElement("div", null,
        React.createElement(react_router_dom_1.Link, { to: '/profile', className: 'padding-vertical-5 account-container padding-horizontal-3 bg-white bordered border-very-light-pink grid-x grid-padding-x' },
            React.createElement("div", { className: 'cell small-8 text-left font-size-14 padding-left-4' },
                React.createElement("img", { className: 'h-4 padding-right-3', src: window.accountApp.iconUrls.profile }),
                "Profile"),
            React.createElement("div", { className: 'cell small-4 text-right' },
                React.createElement("i", { id: 'show-profile', className: 'ss-right' })))));
};
exports.default = Profile;
